(function () {
    if (window.location.pathname !== '/fleet') return;

    var selectors = $('.vehicle a').map(function (index, element) {
        return $(element).attr('href');
    });

    $.each(selectors, function (index, selector) {
        var $element = $(selector);

        if ($element.length === 0) {
            var $button = $('a[href="' + selector + '"]');

            $button.addClass('disabled');
        }
    });

    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();

        var target = this.hash,
            $target = $(target);

        if (!$target.offset()) return;

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $target.offset().top,
                },
                900,
                'swing',
                function () {
                    window.location.hash = target;
                }
            );
    });
})();
